// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"524":"b70121ea","852":"3fdb633f"}[chunkId] + ".chunk.css";
};